export enum Scene {
    LandingPage,
    MainPage,
    Lobby,
    Room,
    Game,
    DiscordLeaderboard,
    DiscordStore,
    DiscordAbout,
    DiscordCareers,
    DiscordChampionship25,
    DiscordChampionship26,
    DiscordCommunity,
    DiscordFAQ,
    DiscordPrivacyPolicy,
    DiscordPatchNotes,
    DiscordProfile,
    DiscordGifting,
    DiscordValues,
    DiscordValuesExamples,
    DiscordTerms,
    DiscordPressKit,
    DiscordRefundPolicy,
    DiscordReplay,
    DiscordMore
}
